import { ResetSavingStateAction, SkademeldingActionKeys } from '../../meldskade/reducer/skademelding-actions';
import { SavingState } from '../../reducers/savingState';
import { failureFetchingSporsmal, loadingSporsmalSteg } from '../../sporsmalsflyt/reducer/current-steg';
import { initialSporsmalsflytState, sporsmalsflytReducer } from '../../sporsmalsflyt/reducer/sporsmalsflyt-reducer';
import { initializeSporsmalsflytState, SporsmalsflytState } from '../../sporsmalsflyt/reducer/sporsmalsflyt-state';
import {
    convertFromSporsmalsflytDTO,
    Sporsmal,
    SporsmalsGruppe,
} from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import {
    FetchedKlageSporsmalsflytAction,
    FetchingKlageSporsmalsflytFailedAction,
    FetchingKlageSporsmalsflytsAction,
    KlageActionKeys,
    SaveEtersendingFailureAction,
    SaveKlageAction,
    SaveKlageSuccessAction,
    SaveKlageVedleggFailureAction,
} from './klage-actions';

export interface KlageState {
    sporsmalsflytState: SporsmalsflytState;
    savingState: SavingState;
    sporsmals: Sporsmal[];
    triggered: SporsmalsGruppe[];
    validSession: boolean;
}

const initialState: KlageState = {
    sporsmals: [],
    triggered: [],
    sporsmalsflytState: initialSporsmalsflytState,
    savingState: SavingState.Initial,
    validSession: true,
};

type Actions =
    | FetchingKlageSporsmalsflytsAction
    | FetchedKlageSporsmalsflytAction
    | FetchingKlageSporsmalsflytFailedAction
    | SaveKlageAction
    | SaveKlageSuccessAction
    | SaveEtersendingFailureAction
    | SaveKlageVedleggFailureAction
    | ResetSavingStateAction
    | never;

export const klageReducer = (state: KlageState = initialState, action: Actions = {} as Actions): KlageState => {
    switch (action.type) {
        case KlageActionKeys.FetchingKlageSporsmalsflyt:
            return {
                ...state,
                sporsmalsflytState: { ...state.sporsmalsflytState, currentSteg: loadingSporsmalSteg() },
            };
        case KlageActionKeys.FetchedKlageSporsmalsflyt: {
            const { sporsmalsList, triggered } = convertFromSporsmalsflytDTO(action.sporsmalsflyt);

            return {
                ...state,
                sporsmals: sporsmalsList,
                triggered,
                sporsmalsflytState: initializeSporsmalsflytState(sporsmalsList),
                savingState: SavingState.Initial,
            };
        }
        case KlageActionKeys.FetchingKlageSporsmalsflytFailed:
            return {
                ...state,
                sporsmalsflytState: { ...state.sporsmalsflytState, currentSteg: failureFetchingSporsmal() },
                sporsmals: [],
            };
        case KlageActionKeys.SaveKlage:
            return {
                ...state,
                savingState: SavingState.Saving,
            };
        case KlageActionKeys.SaveKlageSuccess:
            return {
                ...state,
                savingState: SavingState.Success,
            };
        case KlageActionKeys.SaveKlageFailure:
            return {
                ...state,
                savingState: SavingState.Failure,
            };
        case KlageActionKeys.SaveKlageVedleggFailure:
            return {
                ...state,
                savingState: SavingState.UgyldigVedlegg,
            };
        case SkademeldingActionKeys.ResetSavingState:
            return {
                ...state,
                savingState: SavingState.Initial,
            };
        default:
            return {
                ...state,
                sporsmalsflytState: sporsmalsflytReducer(
                    state.sporsmals,
                    state.triggered,
                    state.sporsmalsflytState,
                    action,
                ),
            };
    }
};
